import aws from 'services/aws';
const { API } = aws;

const createSalesMemberMutation = /* GraphQL */ `
  mutation createSalesMember(
    $input: CreateSalesMemberInput!
    $condition: ModelSalesMemberConditionInput
  ) {
    createSalesMember(input: $input, condition: $condition) {
      familyName
      givenName
      email
      id
      languages
      phone
      role
      brand {
        id
        email
      }
    }
  }
`;

const updateSalesMemberMutation = /* GraphQL */ `
  mutation updateSalesMember(
    $input: UpdateSalesMemberInput!
    $condition: ModelSalesMemberConditionInput
  ) {
    updateSalesMember(input: $input, condition: $condition) {
      id
    }
  }
`;

const deleteSalesMemberMutation = /* GraphQL */ `
  mutation deleteSalesMember(
    $input: DeleteSalesMemberInput!
    $condition: ModelSalesMemberConditionInput
  ) {
    deleteSalesMember(input: $input, condition: $condition) {
      id
    }
  }
`;

export const createSaleMember = ({ showLoader, hideLoader, input }) =>
  new Promise((resolve, reject) => {
    showLoader && showLoader?.();

    API.post(createSalesMemberMutation, { input }, true)
      .then((response) => {
        resolve(response.data.createSalesMember);
      })
      .catch((e) => {
        console.error('create-sales-memeber', e);
        reject();
      })
      .finally(() => hideLoader && hideLoader?.());
  });

export const updateSaleMember = ({ showLoader, hideLoader, input }) =>
  new Promise((resolve, reject) => {
    showLoader && showLoader?.();

    API.post(updateSalesMemberMutation, { input }, true)
      .then((response) => {
        resolve(response.data.updateSalesMember);
      })
      .catch((e) => {
        console.error('update-sales-memeber', e);
        reject();
      })
      .finally(() => hideLoader && hideLoader?.());
  });

export const deleteSaleMember = ({ showLoader, hideLoader, input }) =>
  new Promise((resolve, reject) => {
    showLoader && showLoader?.();

    API.post(deleteSalesMemberMutation, { input }, true)
      .then((response) => {
        resolve(response.data.deleteSalesMember);
      })
      .catch((e) => {
        console.error('delete-sales-memeber', e);
        reject();
      })
      .finally(() => hideLoader && hideLoader?.());
  });
